import { A11y, Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperNavButtons from "../sliderButtons/SwiperNavButton";

interface data {
  RecordId: number;
  logo: string;
  AltImg: string;
}

interface Props {
  WhoWeAreSliderData: data[];
}

const WhoWeAreSlider: React.FC<Props> = ({ WhoWeAreSliderData }) => {
  return (
    <>
      <Swiper
        modules={[Navigation, Pagination, A11y, Autoplay]}
        spaceBetween={10}
        slidesPerView={3}
        loop={true} // Enable looping
        autoplay={{
          // Set autoplay configuration
          delay: 2500, // Duration for each slide (in milliseconds)
          disableOnInteraction: false, // Continue autoplay after user interaction
        }}
        breakpoints={{
          320: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          480: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          640: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
        }}
      >
        {WhoWeAreSliderData.map((data) => (
          <SwiperSlide
            key={data.RecordId}
            className="d-flex partners-slider slick-initialized slick-slider"
          >
            <img
              src={data.logo}
              className="whoimg img-fluid"
              alt={data.AltImg}
            />
          </SwiperSlide>
        ))}
        <SwiperNavButtons />
      </Swiper>
    </>
  );
};

export default WhoWeAreSlider;
